import baseApi from "./baseApi";

const verificaLogin  = async (email, senha) => {
    try {
        const response = await baseApi.post("/login", {
            email: email,
            password: senha
        })
        return response.data

    } catch(erro) {
        console.log(erro)
    }
}
export default  {
    verificaLogin
}